module.exports = "/assets/data/01a71a62c6fdef9d405583e7d732df02-CO10.data.json";